var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { Inline } from '@doordash/design-language';
export var TimeWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  > * {\n    flex: 1 1 100%;\n    min-width: 76px;\n  }\n"])));
export var TimeSeparatorContainer = styled(Inline)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0 1 auto;\n  min-width: auto;\n"])));